import styles from './FilteredCardsView.module.scss';
import ResultsCount from '../ResultCount/ResultsCount';
import ViewSwitch from '../ViewSwitch/ViewSwitch';
import { useFiltersView } from '../../../../lib/context/FiltersViewContext';
import { useDevice } from '../../../../lib/hooks/device';
import { classes } from '../../../../lib/utils/cssUtils';
import SkeletonSummaryRow from './SkeletonSummaryRow';

const SummaryRow = ({ noresultTab = false }: { noresultTab?: boolean }) => {
  const { allowViewTypeChange, filters, isInEditor, viewType, setViewType, loading } = useFiltersView();
  const device = useDevice();

  if (loading === 'initial') {
    return <SkeletonSummaryRow />;
  }

  return (
    <div className={classes(styles.summaryRow, { [styles.noResults]: noresultTab })}>
      <ResultsCount total={isInEditor && noresultTab ? 0 : filters.totalCount ?? 0} />
      {device === 'desktop' && allowViewTypeChange && !!filters.totalCount && !noresultTab && (
        <ViewSwitch selected={viewType} onSelect={vt => setViewType(vt)} />
      )}
    </div>
  );
};

export default SummaryRow;
